import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import SelfReflectionInteractiveFlow from "@/components/storyboard/selfreflection/SelfReflectionInteractiveFlow";
import { QuizValidationService } from "@/services/QuizValidationService";
import type { TextSelfReflectionQuestionsData } from "@/types/storyboard";

interface Props {
  data: TextSelfReflectionQuestionsData | string;
  contentElementId: string;
  title: string;
}

export const TextSelfReflectionQuestions = ({
  data,
  contentElementId,
  title,
}: Props) => {
  // Plain-markdown fallback (no structured questions) stays non-interactive.
  if (typeof data === "string") {
    return (
      <div className="rounded-2xl bg-accent px-5 py-6">
        <div className="prose max-w-full text-base">
          <CourseMarkdown>{data}</CourseMarkdown>
        </div>
      </div>
    );
  }

  return (
    <SelfReflectionInteractiveFlow
      id={contentElementId}
      title={title || data.title || "Fragen zur Selbstreflexion"}
      data={data}
      onValidate={(answer, index) =>
        QuizValidationService.validateAnswer({
          type: "self_reflection",
          userInput: answer,
          contentElementId,
          entryIndex: index,
        })
      }
    />
  );
};
